import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, VNode } from 'vue';
import { IonGrid } from '@ionic/vue';

import { ICourselet } from '@/support/models/courselet.interface';

import { useQuiz } from './Composables/quiz';
import { useLottie } from './Composables/lottie';
import { useMedia } from './Composables/media';
import { useText } from './Composables/text';
import { useVideo } from './Composables/video';


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseletContent',
  props: {
    courselet: null
  },
  setup(__props: any) {

const props = __props as { courselet: ICourselet }



const nodes: { values: VNode[]; sortBy: number }[] = [];

if (props.courselet.video) {
  const { component } = useVideo(props.courselet.video);

  nodes.push({
    values: [component],
    sortBy: props.courselet.sortVideo,
  });
}

if (props.courselet.text) {
  const { component } = useText(props.courselet.text);

  nodes.push({
    values: [component],
    sortBy: props.courselet.sortText,
  });
}

if (props.courselet.lottie) {
  const { component } = useLottie(props.courselet.lottie);

  nodes.push({
    values: [component],
    sortBy: props.courselet.sortLottie,
  });
}

if (props.courselet.media) {
  const { components } = useMedia(props.courselet.media);

  nodes.push({
    values: components,
    sortBy: props.courselet.sortMedia,
  });
}

if (props.courselet.quiz) {
  const { component } = useQuiz(props.courselet.quiz, props.courselet.id);

  nodes.push({
    values: [component],
    sortBy: props.courselet.sortQuiz,
  });
}

const content: VNode[] = nodes
  .sort((curr, next) => curr.sortBy - next.sortBy)
  .reduce((acc: VNode[], node): VNode[] => [...acc, ...node.values], []);

const contentClass: string = content.length === 1 ? 'single' : '';

const render = () => h(IonGrid, { class: contentClass }, () => content);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})